import React from 'react';
import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';
import ContactSection from '@/components/home/ContactSection';

export default function ContactPage() {
    return (
        <div className="bg-la-canvas text-la-text min-h-screen">
            <Navbar />
            <main className="pt-20">
                <ContactSection />
            </main>
            <Footer />
        </div>
    );
}
